import { FC } from 'react'

import { AppSwitcher as ElementsAppSwitcher } from '@reapit/elements'
import { usePlatformGetProductIds } from '@reapit-sales/external-api'

import AppSwitcherMenuContent from './AppSwitcherMenuContent/AppSwitcherMenuContent'
import { IframeHandler } from '../../utils'

interface ProductLists {
  id: string
  organisationsId: string
}

const extractProductIds = (products: ProductLists[]): string[] => {
  return products.map((product) => product.id)
}

export const AppSwitcher: FC = () => {
  // To do: This is an interim solution to avoid the skeleton loading state (no support) and error handling
  // As there is no support from elements yet for onClick prop in the AppSwitcher
  // Once we will have suppport requested, we can extract the product IDs
  // and handle loading/error states properly like this:
  // const { data: products, isLoading, isError } = usePlatformGetProductIds()
  const products = usePlatformGetProductIds()

  // Safety check to ensure data.products is defined and has the expected structure
  // If data is null or undefined then data?.products is not defined or
  // does not have the expected structure, we return an empty array
  const productList = Array.isArray(products?.data?.products) ? products.data.products : []

  // Extract product IDs from the product list
  const accessibleProductIds = extractProductIds(productList)

  // If the user is not configured for Reapit Connect, we don't render the AppSwitcher
  const isUserConfiguredForReapitConnect = accessibleProductIds.length > 0
  if (!isUserConfiguredForReapitConnect) return null

  return (
    <ElementsAppSwitcher>
      {/* To close popover menu on clicking in the iframe container */}
      <IframeHandler />

      <AppSwitcherMenuContent accessibleProductIds={accessibleProductIds} />
    </ElementsAppSwitcher>
  )
}
